import ArrowLeft from './arrow_left.svg'
import ArrowRight from './arrow_right.svg'

export const icons = { ArrowLeft, ArrowRight }
